import Client from "./Client";
import {notify} from "@kyvg/vue3-notification";

export default class WebPush {

    register() {
        if (this.isBrowserSupportsNotifications()) {
            return navigator.serviceWorker.register('/sw3.js?1');
        } else {
            return new Promise();
        }
    }

    isBrowserSupportsNotifications() {
        return "Notification" in window && "serviceWorker" in navigator && 'PushManager' in window;
    }

    hasSubscription(callback) {
        if (this.isBrowserSupportsNotifications()) {
            navigator.serviceWorker.ready
                .then(registration => {
                    registration.pushManager.getSubscription()
                        .then(subscription => callback(!!subscription))
                        .catch(error => callback(false));
                })
                .catch(error => callback(false));
        } else {
            return false;
        }
    }

    requestPermission() {
        if (!this.isBrowserSupportsNotifications() || !navigator.serviceWorker.ready) {
            return;
        }

        new Promise(function (resolve, reject) {
            const permissionResult =
                Notification.requestPermission(result => resolve(result));

            if (permissionResult) {
                permissionResult.then(resolve, reject);
            }
        })
            .then((permissionResult) => {
                if (permissionResult !== 'granted') {
                    throw new Error('We weren\'t granted permission.');
                }
                this.subscribeUser();
            });

    }

    subscribeUser() {
        if (!this.isBrowserSupportsNotifications()) {
            return;
        }

        navigator.serviceWorker.ready
            .then((registration) => {
                const subscribeOptions = {
                    userVisibleOnly: true,
                    applicationServerKey: this.urlBase64ToUint8Array(
                        'BHf6Y4hdHlyGZJo0f3ZGy4mzsTcVNbTIR2MVdlLGbaOPLNyabO3UKy7bwN68_kJefZso4Q73ODwWZ7ZVe2wmE6I'
                    )
                };

                return registration.pushManager.subscribe(subscribeOptions);
            })
            .then((pushSubscription) => {
                this.savePushSubscription(pushSubscription);
            })
            .catch(e => {
            });
    }

    unsubscribeUser() {
        if (!this.isBrowserSupportsNotifications()) {
            return;
        }

        navigator.serviceWorker.ready.then(registration => {
            registration.pushManager.getSubscription().then(subscription => {
                if (subscription) {
                    subscription.unsubscribe().then((successful) => {
                        if (successful) {
                            this.removePushSubscription(subscription);
                        }
                    }).catch((e) => {
                    });
                }
            });
        });
    }

    urlBase64ToUint8Array(base64String) {
        let padding = '='.repeat((4 - base64String.length % 4) % 4);
        let base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        let rawData = window.atob(base64);
        let outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    savePushSubscription(pushSubscription) {
        Client.post('/api/v1.1/push', pushSubscription)
            .then((res) => {
                notify({
                    type: 'success',
                    text: 'Вы успешно подписались на уведомления',
                });
            })
            .catch((e) => {
            });
    }

    removePushSubscription(pushSubscription) {
        Client.post('/api/v1.1/push/unsubscribe', pushSubscription)
            .then((res) => {
                notify({
                    type: 'success',
                    text: 'Вы успешно отписались от пуш-уведомлений',
                });
            })
            .catch((e) => {
            });
    }
}